module.exports = __webpack_public_path__ + "static/img/background5.599e6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background5.png
// module id = /jRS
// module chunks = 13